"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_responsive_carousel_1 = require("react-responsive-carousel");
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var languageSlice_1 = require("../../features/languages/languageSlice");
require("react-responsive-carousel/lib/styles/carousel.min.css");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
// A project with one photo (or none) stays this long...
var SLIDE_INTERVAL_MS = 6000;
// ...a project with several photos shows each of them this long.
var PHOTO_INTERVAL_MS = 4000;
var CURRENCY_SYMBOL = {
    AMD: '֏',
    USD: '$',
};
var HomeHeroSlider = function (_a) {
    var _b;
    var slides = _a.slides;
    var t = react_i18next_1.useTranslation('common').t;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var _c = react_1.useState(0), currentIndex = _c[0], setCurrentIndex = _c[1];
    var _d = react_1.useState(0), photoIndex = _d[0], setPhotoIndex = _d[1];
    var _e = react_1.useState(false), isPaused = _e[0], setIsPaused = _e[1];
    // A new project always starts from its first photo.
    var goToSlide = function (index) {
        if (index === currentIndex)
            return;
        setCurrentIndex(index);
        setPhotoIndex(0);
    };
    // Our own autoplay instead of the carousel's fixed interval, so every photo
    // of a project gets shown before moving on:
    // 1. Paused while the mouse is over the slider (like stopOnHover before).
    // 2. The project has a next photo -> show it after PHOTO_INTERVAL_MS.
    // 3. Last photo (or a single photo / none) -> next project, looping to the
    //    first one; one photo or none waits SLIDE_INTERVAL_MS as before.
    // Arrows, dots and swipes change currentIndex, which restarts this timer.
    react_1.useEffect(function () {
        var _a, _b;
        if (isPaused || !slides.length)
            return undefined;
        var photoCount = (_b = (_a = slides[currentIndex]) === null || _a === void 0 ? void 0 : _a.images.length) !== null && _b !== void 0 ? _b : 0;
        var hasNextPhoto = photoIndex < photoCount - 1;
        var delay = photoCount > 1 ? PHOTO_INTERVAL_MS : SLIDE_INTERVAL_MS;
        var timer = window.setTimeout(function () {
            if (hasNextPhoto) {
                setPhotoIndex(photoIndex + 1);
                return;
            }
            setCurrentIndex((currentIndex + 1) % slides.length);
            setPhotoIndex(0);
        }, delay);
        return function () { return window.clearTimeout(timer); };
    }, [currentIndex, photoIndex, isPaused, slides]);
    // Slide text is stored in all three languages; if the current language
    // is empty, fall back to Armenian, which Nova requires.
    var localize = function (text) {
        return text[currentLanguage] || text.hy;
    };
    // Dots live outside the slides, so the wrapper takes the current
    // slide's scheme to colour the active dot.
    var currentScheme = (_b = slides[currentIndex]) === null || _b === void 0 ? void 0 : _b.colorScheme;
    var formatPrice = function (price) {
        return CURRENCY_SYMBOL[price.currency] + " " + price.amount.toLocaleString('en-US');
    };
    if (!slides.length) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.slider, styles_module_scss_1.default["scheme_" + currentScheme]), onMouseEnter: function () { return setIsPaused(true); }, onMouseLeave: function () { return setIsPaused(false); } },
        react_1.default.createElement(react_responsive_carousel_1.Carousel, { infiniteLoop: true, swipeable: true, emulateTouch: true, selectedItem: currentIndex, onChange: goToSlide, showThumbs: false, showStatus: false, renderArrowPrev: function (onClick, hasPrev, label) {
                return hasPrev && (react_1.default.createElement("button", { type: "button", className: classnames_1.default(styles_module_scss_1.default.arrow, styles_module_scss_1.default.arrow_prev), onClick: onClick, "aria-label": label }, "\u2039"));
            }, renderArrowNext: function (onClick, hasNext, label) {
                return hasNext && (react_1.default.createElement("button", { type: "button", className: classnames_1.default(styles_module_scss_1.default.arrow, styles_module_scss_1.default.arrow_next), onClick: onClick, "aria-label": label }, "\u203A"));
            }, renderIndicator: function (onClick, isSelected, index, label) {
                var _a;
                return (react_1.default.createElement("li", { className: classnames_1.default(styles_module_scss_1.default.dot, (_a = {},
                        _a[styles_module_scss_1.default.dot_active] = isSelected,
                        _a)), onClick: onClick, onKeyDown: onClick, role: "button", tabIndex: 0, "aria-label": label + " " + (index + 1) }));
            } }, slides.map(function (slide, index) {
            var _a;
            return (react_1.default.createElement("div", { key: slide.id, className: classnames_1.default(styles_module_scss_1.default.slide, styles_module_scss_1.default["scheme_" + slide.colorScheme], (_a = {}, _a[styles_module_scss_1.default.slide_placeholder] = !slide.images.length, _a)) },
                slide.images.length > 0 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.photos }, slide.images.map(function (src, i) {
                    var _a;
                    var visiblePhoto = index === currentIndex ? photoIndex : 0;
                    return (react_1.default.createElement("div", { key: src, className: classnames_1.default(styles_module_scss_1.default.photo, (_a = {},
                            _a[styles_module_scss_1.default.photo_active] = i === visiblePhoto,
                            _a)), style: {
                            backgroundImage: "url(" + src + ")",
                        } }));
                }))),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.developer }, slide.developer),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.tag }, localize(slide.tag)),
                    react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, slide.title),
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.description }, localize(slide.description)),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.chips },
                        slide.rooms && (react_1.default.createElement("span", { className: styles_module_scss_1.default.chip }, t('HOME.HERO_SLIDER.ROOMS', {
                            rooms: slide.rooms,
                        }))),
                        slide.handoverYear && (react_1.default.createElement("span", { className: styles_module_scss_1.default.chip }, t('HOME.HERO_SLIDER.HANDOVER', {
                            year: slide.handoverYear,
                        }))),
                        slide.priceFrom && (react_1.default.createElement("span", { className: styles_module_scss_1.default.chip }, t('HOME.HERO_SLIDER.PRICE_FROM', {
                            price: formatPrice(slide.priceFrom),
                        })))),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.actions },
                        slide.link && (react_1.default.createElement("a", { className: styles_module_scss_1.default.button_primary, href: slide.link }, t('HOME.HERO_SLIDER.VIEW_APARTMENTS'))),
                        slide.tour3dUrl && (react_1.default.createElement("a", { className: styles_module_scss_1.default.button_secondary, href: slide.tour3dUrl, target: "_blank", rel: "noopener noreferrer" },
                            "\uD83C\uDFA5 ",
                            t('HOME.HERO_SLIDER.TOUR_3D')))))));
        }))));
};
exports.default = HomeHeroSlider;
